import { useTranslation } from "react-i18next";

import "modules/PrivacyAndSecurityDashboard/components/DataProtectionOfficer/DataProtectionOfficer.scss";

import type { User } from "models";

type DataProtectionOfficerProps = {
  title: string;
  dataProtectionOfficer: User;
  isClaireDPO?: boolean;
};

export const DataProtectionOfficer = ({ title, isClaireDPO, dataProtectionOfficer }: DataProtectionOfficerProps) => {
  const { t } = useTranslation();

  return (
    <div className="DataProtectionOfficer">
      <div className="DataProtectionOfficer__title">{title}</div>

      <div>
        <div className="DataProtectionOfficer__row">
          <div>{t("v8_name", "Name")}</div>
          <div>
            {dataProtectionOfficer.first_name} {dataProtectionOfficer.last_name}
          </div>
        </div>
        {!isClaireDPO && (
          <>
            <div className="DataProtectionOfficer__row">
              <div>{t("v8_address", "Address")}</div>
              <div>
                {dataProtectionOfficer.address1} {dataProtectionOfficer.address2}
              </div>
            </div>
            <div className="DataProtectionOfficer__row">
              <div>{t("v8_phone", "Phone")}</div>
              <div>{dataProtectionOfficer.phone}</div>
            </div>
          </>
        )}
        <div className="DataProtectionOfficer__row">
          <div>{t("v8_email", "Email")}</div>
          <div>{dataProtectionOfficer.email}</div>
        </div>
      </div>
    </div>
  );
};
